/**
 * Fonctions communes des onglets de tarifs : montant affiché selon la saisie (avant taxes ou taxes incluses),
 * lecture d'une case (vide = non offert, 0 = gratuit, « sd » ou « sur demande » = sur demande).
 */
import type { CellInput, TariffCell, Tariffs } from '../../api'

export type TabProps = {
  orgId: number
  data: Tariffs
  onSaved: (next: Tariffs) => void
  onListChanged?: () => void
}

const ON_REQUEST = /^(sd|s\.d\.|sur demande|on request|\?)$/i

/** Ce qu'on montre dans une case : le montant tel que l'organisation le saisit. */
export function cellText(cell: TariffCell | undefined, includeTax: boolean): string {
  if (!cell) return ''
  if (cell.on_request) return 'sur demande'
  const value = includeTax ? cell.amount_with_tax : cell.amount
  return value == null ? '' : value.replace(/\.00$/, '')
}

/** Une case saisie → ce qu'on envoie (le serveur convertit si l'organisation saisit taxes incluses). */
export function parseCell(text: string, categoryId: number | null): CellInput {
  const v = text.trim()
  if (ON_REQUEST.test(v)) return { category_id: categoryId, amount: null, on_request: true }
  return { category_id: categoryId, amount: v === '' ? null : v.replace(',', '.').replace('$', '').trim(), on_request: false }
}

export function numOrNull(v: string): number | null {
  const n = Number(v)
  return v.trim() === '' || Number.isNaN(n) ? null : n
}

export function errorText(e: unknown): string {
  return e instanceof Error ? e.message : String(e)
}
